import '@ioc/mediator'
import { Navigate, Route, Routes } from 'react-router'

import Notifications from '@ui/features/notifications/Notifications'

import Layout from './Layout'
import usePages from './hooks/usePages'
import useRefreshOverleafStatus from './hooks/useRefreshOverleafStatus'

export default function App() {
  const pages = usePages()

  useRefreshOverleafStatus()

  return (
    <>
      <Routes>
        <Route element={<Layout pages={pages} />}>
          {pages.map((page, i) => (
            <Route key={page.path} path={page.path} element={page.element} index={i === 0} />
          ))}
          <Route path='*' element={<Navigate to='/' replace={true} />} />
        </Route>
      </Routes>
      <Notifications />
    </>
  )
}
